import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {ContactModel, ContactType} from "@/components/communications/models/contactModel";
import Personalization from "@/components/communications/components/Personalization.vue";
import VueSimpleSpinner from 'vue-simple-spinner';
import GenericModal from "@/componentsReusable/genericModal.vue";
import {CommunicationType} from "@/components/communications/CommunicationInterfaces";
import HttpMixin from "@/mixins/HttpMixin";

interface SenderEmailAddress {
  senderEmailAddress: string;
}
@Component({
  components: {
    Personalization,
    VueSimpleSpinner,
    GenericModal,
  },
  mixins: [HttpMixin],
})
export default class CampaignMessageCard extends Vue {
  @Prop({type: String, required: true, default: ''})
  messageTypeText!: string;
  @Prop({type: Array, required: true, default: [] as ContactModel[]})
  contacts!: ContactModel[];

  title = '';
  subject = '';
  fullMessage = '';
  sendingMessage = false;
  maxCharacters = 420;
  email = '';
  bccAddresses = '';
  showRestartConfirmationModal = false;
  checkMessageError = false;
  checkTitleError = false;
  checkSubjectError = false;
  checkSenderEmailError = false;
  senderEmailAddresses = [] as SenderEmailAddress[];

  get titleErrorMessage(): string {
    if(this.checkTitleError && this.title.trim().length === 0) {
      return "Title is required";
    }
    return '';
  }

  get messageErrorMessage(): string {
    if(this.checkMessageError && this.message.trim().length === 0) {
      return "message is required";
    }
    return '';
  }

  get subjectErrorMessage(): string {
    if(this.checkSubjectError && this.messageTypeText === 'Emails' && this.subject.trim().length === 0){
      return 'Subject is required';
    }
    return '';
  }

  get senderEmailErrorMessage(): string {
    if (this.checkSenderEmailError && (!this.email || this.email === '')) {
      return 'Sender Email is Required';
    }
    return '';
  }

  get remainingCharacters(): number {
    return this.message.length;
  }

  get message(): string {
    return this.messageTypeText === 'Emails' ? this.fullMessage
      : this.fullMessage.substring(0
        , Math.min(this.fullMessage.length, this.maxCharacters
        )
      );
  }

  set message(value: string) {
    this.fullMessage = value;
  }

  get sendDisabled(): boolean {
    return this.titleErrorMessage.length > 0
      || this.subjectErrorMessage.length > 0
      || this.message.length === 0
      || this.senderEmailErrorMessage.length > 0

  }

  get textAreaDisabled(): boolean {
    return this.messageTypeText === 'Emails' ? false
      : this.fullMessage.length >= this.maxCharacters;
  }

  @Watch('messageTypeText')
  async messageTypeTextChanged(){
    await this.restartConfirmed();
  }

  async created() {
    await this.loadData();
  }

  startOver() {
    this.showRestartConfirmationModal = true;
  }

  async restartConfirmed() {
    await this.cancelMessage();
    this.subject = '';
    this.bccAddresses = '';
    this.title = '';
    this.$emit('startOver');
    this.showRestartConfirmationModal = false;
  }

  textAreaPersonalizationSelected(newMessage: string) {
    this.message = newMessage;
  }

  subjectLinePersonalizationSelected(newMessage: string) {
    this.subject = newMessage;
  }

  async loadData() {
    this.senderEmailAddresses = await this.httpGet<SenderEmailAddress[]>('/communication-campaigns/sender-signature', '') as SenderEmailAddress[];
  }

  async sendMessage() {
    this.checkSenderEmailError = this.checkSubjectError = this.checkTitleError = this.checkMessageError = true;
    if (this.sendDisabled ) {
      return;
    }
    const sendCampaignData = {
      message: this.message,
      communicationTypeId: this.messageTypeText === 'Emails' ? CommunicationType.EMAIL : CommunicationType.SMS,
      providerIds: this.getContactsByType(ContactType.Provider),
      facilityContactIds: this.getContactsByType(ContactType.FacilityContact),
      title: this.title,
      bccEmailAddresses: this.bccAddresses.replace(';',','),
      subject: this.subject,
      isCampaignMessage: true,
      senderEmailAddress: this.email
    };
    this.sendingMessage = true;
    try {
      await this.httpPost('/communications', 'Failed to send Reply', sendCampaignData);
      this.$emit('messageSent');
    } finally {
      this.sendingMessage = false;
    }
  }

  getContactsByType(contactType: ContactType) {
    return this.contacts.filter(c => c.contactType === contactType).map(c => c.id);
  }

  async cancelMessage() {
    this.message = '';
  }
}



// WEBPACK FOOTER //
// ./src/components/communications/campaign/CampaignMessageCard/CampaignMessageCard.ts